import styled from 'styled-components';

export const SectionNameWrapper = styled.span`
  font-weight: 500;
`;
